import React, { useEffect, useState } from "react";
import { Form, Input, Button, Checkbox, Alert } from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import "./Login.css"; // Add your styles here
import { useDispatch, useSelector } from "react-redux";
import { loginUser } from "../../actions/AuthActions";
import { mapFirebaseAuthError } from "../../utils";

import { Link, Navigate } from "react-router-dom";
import { auth } from "../../App";
import { logPageVisit } from "../../actions/AnalyticsActions";

const Login = () => {
const dispatch =useDispatch();

const { loading, error } = useSelector((state) => state.auth); // Assuming state.auth has loading & error


const user = useSelector((state) => state.user.user);
// const loading = useSelector((state) => state.user.userLoading);

    const { translations, language } = useSelector((state) => state.language);



  useEffect(() => {
    dispatch(logPageVisit("Login"));
  }, [dispatch]);

     useEffect(() => {
            window.scrollTo(0, 0);
        }, []);


  const handleLogin = (values) => {
    // console.log("Login details:", values);
   
    dispatch(loginUser(values.email, values.password, values.remember));

  };



  if (auth.currentUser) {
  // if (user) {
    // User logged in
    return <Navigate to="/dashboard" />;
}





  return (
    <div style={{minHeight: "100vh"}} className="login-container">
      <div className="login-card">
        <h1>{translations.login.members}</h1>
        <p>{translations.login.loginMessage}</p>
        <Form
          name="login-form"
          className="login-form"
          onFinish={handleLogin}
          initialValues={{ remember: false }}
        >
          {/* Email Input */}
          <Form.Item
            name="email"
            rules={[
              { required: true, message: `${translations.login.enterEmail}` },
              { type: "email", message: `${translations.login.validEmail}` },
            ]}
          >
            <Input
              prefix={<UserOutlined className="input-icon" />}
              placeholder={`${translations.login.email}`}
            />
          </Form.Item>

          {/* Password Input */}
          <Form.Item
            name="password"
            rules={[{ required: true, message: `${translations.login.enterPassword}` }]}
          >
            <Input.Password
              prefix={<LockOutlined className="input-icon" />}
              placeholder={`${translations.login.password}`}
            />
          </Form.Item>

          {/* Remember Me and Forgot Password */}
          <Form.Item>
    <Form.Item name="remember" valuePropName="checked" noStyle>
      <Checkbox>{translations.login.remember}</Checkbox>
    </Form.Item>
  </Form.Item>

          {error && <Alert type="error" message={mapFirebaseAuthError(error.code)}  style={{marginBottom:'16px'}}/>}

          {/* Login Button */}
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              className="login-form-button"
              loading={loading}
            >
              {translations.login.logIn}
            </Button>
          </Form.Item>
        </Form>
        <div className="login-footer">
          <p>
            {translations.login.signUp1} <Link to="/register">{translations.login.signUp2}</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
